export function getHostOriginSite() {
    if (['demo.easyclapweb.com'].includes(window.location.hostname)) {
        return 'demo'
    }
    if (['localhost'].includes(window.location.hostname)) {
        return 'site'
    }
    return 'prod'
}
